export default "__VITE_ASSET__CHi9MIbC__"